<template>
  <div>
    <component
      :is="component"
      v-if="isError"
    />
    <slot v-else/>
  </div>
</template>

<script>
export default {
  name: 'ErrorBoundary',
  props: {
    isError: {
      type: Boolean,
      default: false,
    },
    component: {
      type: Function,
      required: true,
    },
  },
};
</script>
